<template>
  <div class="masterStorageTable">
    <v-data-table
      :headers="headersTmp"
      :items="masterItems"
      :item-key="itemKey"
      :hide-default-header="false"
      :items-per-page="-1"
      hide-default-footer
      :no-data-text="$t('common.common_not-register')"
      class="rounded-lg"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr
            v-for="(item, trIndex) in getFormatRow(items)"
            :key="`group-${trIndex}`"
            v-bind:class="{
              rowColor: item.storageIndex % 2 !== 0
            }"
          >
            <template v-for="(header, parentIndex) in headersTmp">
              <td
                v-bind:class="{
                  tdStyleCenter: getAlign(header.value) === 'center',
                  tdStyleEnd: getAlign(header.value) === 'end',
                  DisplayNone: getAlign(header.value) === ' d-none',
                  firstTd: item.isLastRow && 0 === parentIndex,
                  lastTd:
                    item.isLastRow && headersTmp.length - 1 === parentIndex
                }"
                :key="parentIndex"
                v-if="
                  (item.isFirst && !('rowspan' in header)) || header.rowspan
                "
                :rowspan="item.recipientLength"
                class="parentIndexTd"
              >
                <slot :name="header.value" v-bind:item="item.storageList">
                  {{ getDefaultValue(item.storageList, header) }}
                </slot>
              </td>
              <!-- 受取人の項目表示 -->
              <td
                v-if="'rowspan' in header && !header.rowspan"
                :key="parentIndex"
              >
                <div v-if="isName(header, 'storageRecipientName')">
                  {{ item.recipientInfo.name || '-' }}
                </div>

                <div v-if="isName(header, 'storageRecipientAddress')">
                  <div
                    v-if="
                      getPostalCode(
                        item.recipientInfo.postalCode,
                        item.recipientInfo.countryId
                      ) ||
                      getRegionName(
                        item.recipientInfo.countryId,
                        item.recipientInfo.regionId
                      ) ||
                      item.recipientInfo.address1 ||
                      item.recipientInfo.address2
                    "
                    class="my-2"
                  >
                    <v-row
                      v-if="
                        getPostalCode(
                          item.recipientInfo.postalCode,
                          item.recipientInfo.countryId
                        )
                      "
                      no-gutters
                    >
                      {{
                        '〒' +
                        getPostalCode(
                          item.recipientInfo.postalCode,
                          item.recipientInfo.countryId
                        )
                      }}
                    </v-row>
                    <v-row no-gutters>{{
                      (getRegionName(
                        item.recipientInfo.countryId,
                        item.recipientInfo.regionId
                      ) || '') + (item.recipientInfo.address1 || '')
                    }}</v-row>
                    <v-row no-gutters>{{ item.recipientInfo.address2 }}</v-row>
                  </div>
                  <div v-else class="my-2">{{ '-' }}</div>
                </div>

                <div v-if="isName(header, 'storageRecipientPhoneNumber')">
                  <div
                    v-if="
                      getPhoneNumber(
                        item.recipientInfo.phoneNumber,
                        item.recipientInfo.phoneNumberCountryId
                      )
                    "
                  >
                    {{
                      'TEL:' +
                      getPhoneNumber(
                        item.recipientInfo.phoneNumber,
                        item.recipientInfo.phoneNumberCountryId
                      )
                    }}
                  </div>
                  <div v-else>{{ '-' }}</div>
                </div>
                <div v-if="isName(header, 'storageRecipientNote')">
                  {{ item.recipientInfo.note || '-' }}
                </div>
              </td>
            </template>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { commonUtil, countryUtil, countryCallingCodeUtil } from '@/util'
export default {
  props: {
    headers: [],
    masterItems: {
      type: Array,
      require: true,
      default: () => []
    },
    itemKey: String
  },
  data: () => ({
    itemsDetail: [],
    headersTmp: []
  }),
  created() {
    this.createHeaders()
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    getRegionName(countryId, regionId) {
      return countryUtil.getRegionInfo(countryId, regionId).label
    },
    getPostalCode(postalCode, countryId) {
      return commonUtil.formatPostalCode(postalCode, countryId)
    },
    getPhoneNumber(phone, callingCode) {
      return countryCallingCodeUtil.formatPhoneNumber(phone, callingCode)
    },
    getFormatRow(storageList) {
      return storageList.reduce((result, current, currentIndex) => {
        const isLastRow = storageList.length - 1 === currentIndex

        if (!current.storageRecipients.length) {
          result.push({
            storageIndex: currentIndex,
            isLastRow: isLastRow,
            storageId: current.storageId,
            isFirst: true,
            recipientIndex: -1,
            recipientLength: 1,
            recipientInfo: {},
            storageList: current
          })
        } else {
          current.storageRecipients.map((ele, index) => {
            result.push({
              storageIndex: currentIndex,
              isLastRow: isLastRow,
              storageId: current.storageId,
              isFirst: index === 0,
              recipientIndex: index,
              recipientLength: current.storageRecipients.length,
              recipientInfo: ele,
              storageList: current
            })
          })
        }

        return result
      }, [])
    },

    createHeaders() {
      this.itemsDetail = this.headers.map((header) => {
        return {
          value: header.value,
          inputType: 'inputType' in header ? header.inputType : '',
          unit: 'unit' in header ? header.unit : '',
          align: 'align' in header ? header.align : ''
        }
      })
      this.headersTmp = this.headers.map((header) => {
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        delete tmp.inputType
        delete tmp.unit
        return tmp
      })
    },
    isName(header, name) {
      return header.value === name
    },
    getRowValue(obj, path) {
      let tmp = this.getValue(obj, path)
      return typeof tmp === 'undefined' ? '' : tmp
    },
    getValue(obj, path) {
      if (!path) return obj
      const properties = path.split('.')
      return this.getValue(obj[properties.shift()], properties.join('.'))
    },
    getItemsDetailRecord(value) {
      return this.itemsDetail.find((header) => header.value === value)
    },
    getAlign(value) {
      const tmp = this.getItemsDetailRecord(value)
      return tmp ? tmp.align : ''
    },
    getDefaultValue(item, header) {
      const val = this.getRowValue(item, header.value)
      return val ? val : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.masterStorageTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    border-collapse: collapse;
    border-left: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    border-collapse: collapse;
    border-left: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table .parentIndexTd:last-child {
    border-right: 1px solid #d8d8d8 !important;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }

  ::v-deep .v-data-table thead th:first-child {
    border-radius: 10px 0 0 0;
  }
  ::v-deep .v-data-table thead th:last-child {
    border-radius: 0 10px 0 0;
  }

  .rowColor {
    background-color: rgba(213, 213, 213, 0.1);
  }
  .firstTd {
    border-radius: 0 0 0 10px;
  }
  .lastTd {
    border-radius: 0 0 10px 0;
  }
}
</style>
